/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Complaints_LabelInputs */

const en_company_complaints_label = /** @type {(inputs: Company_Complaints_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complaints`)
};

/**
* | output |
* | --- |
* | "Complaints" |
*
* @param {Company_Complaints_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const company_complaints_label = /** @type {((inputs?: Company_Complaints_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Complaints_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_company_complaints_label(inputs)
});